<template>
  <div class="chat-window" :class="{ '-minimize': mini }">
    <div class="chat-window-content" chat-end>
      <div class="chat-window__head">
        <div class="chat-window__head__icon"></div>
        <div class="chat-window__head__title">Sonlandır</div>
        <div class="chat-window__head__buttons">
          <div class="chat-window__head__buttons__minimize" @click="minimize()"></div>
        </div>
      </div>
      <div class="chat-window__content">
        <div class="chat-ending">
          <div class="chat-ending__text">Değerlendirmeniz için teşekkür eder, hayırlı günler dileriz.</div>
          <div class="chat-ending__button" @click="closeChat()">Sonlandır</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      mini: false
    }
  },
  methods: {
    closeChat: function () {
      this.$emit('changeStep', 1)
    },
    minimize: function () {
      this.mini = !this.mini
    }
  }
}
</script>